import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AlertTriangle, LogOut } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Banner displayed at the top of the layout when an admin is impersonating another user.
 * Provides a one-click way to switch back to the original admin session.
 */
const ImpersonationBanner = () => {
    const { isImpersonating, stopImpersonation, user } = useAuth();
    const navigate = useNavigate();

    if (!isImpersonating) return null;

    const handleSwitchBack = () => {
        const ok = stopImpersonation();
        if (ok) {
            toast.success('Zurück zum Admin-Account');
            navigate('/system', { replace: true });
        } else {
            toast.error('Konnte nicht zum Admin zurückwechseln');
        }
    };

    const name = `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.username || 'Benutzer';

    return (
        <div
            className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 shadow-lg"
            data-testid="impersonation-banner"
            style={{ paddingTop: 'env(safe-area-inset-top)' }}
        >
            <div className="flex items-center justify-between gap-3 px-4 py-2 md:ml-64">
                <div className="flex items-center gap-2 min-w-0">
                    <AlertTriangle className="w-5 h-5 shrink-0" />
                    <p className="text-sm font-medium truncate">
                        Du bist als <strong>{name}</strong> eingeloggt (Impersonation)
                    </p>
                </div>
                <button
                    onClick={handleSwitchBack}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-amber-950 text-amber-50 hover:bg-amber-900 active:bg-amber-900 transition-colors text-sm font-medium shrink-0"
                    data-testid="impersonation-stop-btn"
                >
                    <LogOut className="w-4 h-4" />
                    <span className="hidden sm:inline">Zurück zum Admin</span>
                    <span className="sm:hidden">Zurück</span>
                </button>
            </div>
        </div>
    );
};

export default ImpersonationBanner;
